<template>
  <el-card>
    <div slot="header" class="font-weight-bold text-left">
      {{ $t('general.recent_user') }}
    </div>
    <div>
      <table class="w-100 el-table">
        <thead>
          <tr>
            <th>{{ $t('general.firstname') }}</th>
            <th>{{ $t('general.lastname') }}</th>
            <th>{{ $t('general.company') }}</th>
            <th>{{ $t('general.username') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="user in users" :key="user.id">
            <td>{{ user.get('firstname') }}</td>
            <td>{{ user.get('lastname') }}</td>
            <td>{{ user.get('company') }}</td>
            <td>{{ user.get('username') }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </el-card>
</template>

<script>
export default {
  name: 'RecentUserCard',
  components: {},
  props: {},
  async mounted() {
    let query = new this.$parse.Query('User');
    query.addDescending('createdAt');
    query.limit(5);
    this.users = await query.find();
  },
  destroyed() {},
  data() {
    return {
      users: [],
    };
  },
  computed: {},
  methods: {},
};
</script>

<style scoped></style>
